// Item-specific sync wire schemas.

import { items } from '../../../drizzle/v2Schema';
import { wireFromDrizzle } from './lib/wireFromDrizzle';
import {
  checkpointSchema,
  makePullOutput,
  PULL_BATCH_MAX,
  syncEntityIdSchema,
  syncUserIdSchema,
} from './schemas';
import { z } from 'zod/v4';

export const itemDocSchema = wireFromDrizzle(items, {
  overrides: {
    id: () => syncEntityIdSchema,
    processId: () => syncEntityIdSchema,
    type: () => z.enum(['COMMENT', 'TODO', 'FILE']),
    userId: () => syncUserIdSchema,
  },
  softDelete: 'deletedAt',
});

export type ItemDocWire = z.infer<typeof itemDocSchema>;

export const itemsPullInput = z.object({
  batchSize: z.number().int().min(1).max(PULL_BATCH_MAX),
  checkpoint: checkpointSchema.nullable(),
  processId: syncEntityIdSchema,
});

export const itemsPullOutput = makePullOutput(itemDocSchema);

export type ItemsPullInput = z.infer<typeof itemsPullInput>;
export type ItemsPullOutput = z.infer<typeof itemsPullOutput>;
